const endpoints = {
  GET_CONFIG: '/v2/ccp/user/getConfig',
  ENABLE_RECURRING: '/v2/ccp/user/setRecurring',
  CCP_CHARGE_FOR_PHOTO_REVEAL: '/v2/ccp/external/chargeForPhotoReveal',
  CCP_CHARGE_FOR_VOICE_MESSAGE_REVEAL: '/v2/ccp/external/chargeForVoiceMessageReveal',
  UNLOCK_MESSAGE: '/v2/ccp/external/unlockMessage',
  UNLOCK_FEATURED_AP: '/v2/ccp/user/unlockFeaturedAP',
  REVEAL_GIFT: '/v2/ccp/external/revealGift',
}

export class User {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async getConfig(data = {}, opts = {}) {
    return this.requester.get(endpoints.GET_CONFIG, data, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async enableRecurring(data = {}, opts) {
    return this.requester.post(endpoints.ENABLE_RECURRING, data, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async chargeForPhotoReveal({ conversationUid, photoUrl, messageId }, opts = {}) {
    return this.requester.post(endpoints.CCP_CHARGE_FOR_PHOTO_REVEAL, { conversationUid, photoUrl, messageId }, opts)
  }

  async chargeForVoiceMessageReveal({ conversationUid, url, messageId }, opts = {}) {
    return this.requester.post(endpoints.CCP_CHARGE_FOR_VOICE_MESSAGE_REVEAL, { conversationUid, url, messageId }, opts)
  }

  async unlockMessage({ messageId }, opts = {}) {
    return this.requester.post(endpoints.UNLOCK_MESSAGE, { messageId }, opts)
  }

  async unlockFeaturedAp({ conversationUid, apUid }, opts = {}) {
    return this.requester.post(endpoints.UNLOCK_FEATURED_AP, { conversationUid, apUid }, opts)
  }

  async revealGift({ messageId }, opts = {}) {
    return this.requester.post(endpoints.REVEAL_GIFT, { messageId }, opts)
  }
}
